module.exports = __webpack_public_path__ + "img/tc.abb6f012.svg";